/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import {
  Button,
  cn,
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@repo/ui";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import {
  useAutocompleteAllLocations,
  useGetBagTypes,
  // eslint-disable-next-line import/no-unresolved
} from "services/lookups-queries";
// eslint-disable-next-line import/no-unresolved
import SearchableDropdown from "components/searchableDropdown";
import MultiSelect from "react-select";

export default function OnwardLocations({
  onNextStep,
  isValid,
  onAddLocations,
  addedLocations = [],
  onPrevStep,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [locations, setLocations] = useState([]);
  const [allowedContainerTypes, setAllowedContainerTypes] = useState([]);

  // master site list (contains barcode and fallback details)
  const { data: autocompleteResults, isFetching: isFetchingAutocomplete } =
    useAutocompleteAllLocations(searchTerm);

  const form = useForm({
    defaultValues: {
      locationName: "",
      locationId: "",
      locationType: "",
      bagTypes: [],
    },
  });

  const { handleSubmit, control, reset, setValue } = form;

  const { data: bagTypeList } = useGetBagTypes();

  const formValidationRules = {
    cashCenterId: { required: "Please Select Cash Center" },
    locationId: { required: "Please Enter Location Id" },
    bagType: { required: "Please Enter Location Code" },
  };

  const onLocationChange = (value) => {
    const findLocation = autocompleteResults?.data?.find(
      (item) => item.locationId === value,
    );
    setValue("cashCenter", findLocation?.cashCenter || "");
    setValue("customer", findLocation?.customer || "");
    setValue("locationName", findLocation?.locationName || "");
    setValue("locationType", findLocation?.locationType || "");
    setValue("barcode", findLocation?.barcode || "");
  };

  const submitInfo = (data) => {
    delete data.bagTypes;
    if (currentEditing !== null) {
      const updatedData = locations?.map((_i, index) => {
        if (index === currentEditing) return { ...data, allowedContainerTypes };
        return _i;
      });
      onAddLocations(updatedData);
      setLocations(updatedData);
    } else {
      onAddLocations([...locations, { ...data, allowedContainerTypes }]);
      setLocations([...locations, { ...data, allowedContainerTypes }]);
    }
    reset({
      locationName: "",
      locationId: "",
      locationType: "",
      bagTypes: [],
    });
    setCurrentEditing(null);
    setSearchTerm("");
    setAllowedContainerTypes([]);
  };

  function ContainerCell({ dataItem }) {
    return (
      <td>
        {dataItem?.allowedContainerTypes?.map((i) => i.description)?.join(", ")}
      </td>
    );
  }

  function EditCell({ dataItem, dataIndex }) {
    return (
      <td>
        <div
          title="Edit Cassette"
          className="cursor-pointer flex justify-center"
          onClick={() => {
            reset({
              ...dataItem,
              bagTypes: dataItem.allowedContainerTypes?.map((i) => ({
                label: `${i.code}-${i.description}`,
                value: i,
              })),
            });

            setSearchTerm(`${dataItem?.barcode}`);
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </div>
      </td>
    );
  }

  function DeleteCell({ dataIndex }) {
    return (
      <td>
        <div
          title="Delete Cassette"
          className="cursor-pointer flex justify-center"
          onClick={() => {
            setCurrentEditing(null);
            reset({
              locationName: "",
              locationId: "",
              locationType: "",
              bagTypes: [],
            });
            const updateData = locations.filter(
              (_, index) => index !== dataIndex,
            );
            onAddLocations(updateData);
            setLocations(updateData);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </div>
      </td>
    );
  }
  const cancelEditing = () => {
    reset({
      locationName: "",
      locationId: "",
      locationType: "",
      bagTypes: [],
    });
    setCurrentEditing(null);
  };

  useEffect(() => {
    if (!locations?.length && addedLocations?.length) {
      setLocations([...addedLocations]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addedLocations]);

  return (
    <Form {...form}>
      <form onSubmit={handleSubmit(submitInfo)}>
        <div className="flex justify-between w-full">
          <h2 className="font-bold text-2xl">Add Multiple Onward Location</h2>
          <div className="flex gap-4">
            <Button
              type="button"
              variant="secondary"
              onClick={() => onPrevStep()}
            >
              Back
            </Button>
            <Button
              type="submit"
              // disabled={!isValid}
              variant="secondary"
              onClick={() => {
                onNextStep();
              }}
            >
              Next
            </Button>
          </div>
        </div>
        <div className="flex gap-4 w-full">
          <FormField
            isRequired
            control={control}
            name="locationId"
            rules={formValidationRules.locationId}
            render={({ field }) => (
              <FormItem className="max-w-80 w-full">
                <FormLabel>Location</FormLabel>
                <SearchableDropdown
                  placeholder="Search Location"
                  value={field.value}
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                  data={
                    autocompleteResults?.data?.map((item) => ({
                      value: item.locationId,
                      label: `${item.barcode || ""}-${item.locationId}`,
                    })) || []
                  }
                  loading={isFetchingAutocomplete}
                  onChange={(val) => {
                    field.onChange(val);
                    onLocationChange(val);
                  }}
                />

                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="bagTypes"
            rules={formValidationRules.bagType}
            render={({ field }) => (
              <FormItem className="space-y-2 max-w-[420px] w-full">
                <FormLabel>Bag Type</FormLabel>
                <MultiSelect
                  {...field}
                  isSearchable
                  className="h-10"
                  isMulti
                  placeholder="Select Bag Type"
                  options={bagTypeList?.data?.map((item) => ({
                    value: item,
                    label: `${item?.code}-${item?.description}`,
                  }))}
                  onChange={(objArray) => {
                    field.onChange(objArray);
                    setAllowedContainerTypes(objArray?.map?.((i) => i.value));
                  }}
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      borderColor: "hsl(var(--input))",
                    }),
                    valueContainer: (baseStyles) => ({
                      ...baseStyles,
                      maxHeight: "96px",
                      overflow: "auto",
                    }),

                    option: (styles, { isFocused, isSelected }) => ({
                      ...styles,
                      backgroundColor: isSelected
                        ? "hsl(var(--secondary))"
                        : isFocused
                          ? "hsl(var(--secondary))"
                          : undefined,
                      color: isSelected
                        ? "#fff"
                        : isFocused
                          ? "#fff"
                          : undefined,
                    }),
                  }}
                />
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        {currentEditing !== null ? (
          <Button
            type="button"
            onClick={cancelEditing}
            variant="secondary"
            className="block ml-auto"
          >
            Cancel
          </Button>
        ) : null}
        <Button
          type="submit"
          variant="secondary"
          className={cn(currentEditing !== null ? "" : "block ml-auto")}
        >
          {currentEditing !== null ? "Edit Location" : "Add Location"}
        </Button>

        <Grid data={locations} style={{ width: "100%" }}>
          <GridColumn title="Cash Center" field="cashCenter" />
          <GridColumn title="Customer" field="customer" />
          <GridColumn title="Location" field="locationName" />
          <GridColumn title="Type" field="locationType" />
          <GridColumn title="Barcode" field="barcode" />
          <GridColumn
            title="Bag Type"
            field="allowedContainerTypes"
            cell={ContainerCell}
          />
          <GridColumn title="Edit" width={120} cell={EditCell} />
          <GridColumn title="Delete" width={120} cell={DeleteCell} />
        </Grid>
      </form>
    </Form>
  );
}
